'use strict';

// testimonials
(()=>{
	'use strict';

	//*************************************************************************
	//phone mask
	const SPMaskBehavior = (val) => {
		return val.replace(/\D/g, '').length === 11 ? '(00) 00000-0000' : '(00) 0000-00009';
	},spOptions = {
		onKeyPress: function(val, e, field, options) {
	    	field.mask(SPMaskBehavior.apply({}, arguments), options);
	    }
	};
	$('.phone-mask').mask(SPMaskBehavior, spOptions);
	//*************************************************************************



	//*************************************************************************
	//open sub menu login
	const openLoginPhone = () => {
		$('.menu-my-account-sent-code').hide();
		$('.menu-my-account-login').fadeIn();
		setTimeout(()=>{
			if ($('.menu-my-account').css('display') === 'block') {
				$('.phone-mask').focus();
				console.log('focus');
			}else{
				console.log('blur');
				$('.phone-mask').blur();
			}
		}, 500)
	}
	//*************************************************************************


	const showAlert = (message) =>{
		$('.msg-alert').addClass('hiden').html(message);
	}


	//*************************************************************************
	$('.btn-send-phone').on('click',(e)=>{
		e.preventDefault();
		$('.msg-alert').removeClass('hiden');

		const phone = $('.phone-mask').val();
		const isPhoneValid = phone.length === 14 || phone.length === 15;

		if (isPhoneValid === false) {
			showAlert('Digite um telefone válido.');
			return;
		}
		$('.phone-typed').html( phone );
		$('.menu-my-account-login').fadeOut(300,()=>{
			$('.menu-my-account-sent-code').fadeIn();
		});
	});

	$('.send-number-retry').on('click',(e)=>{
		e.preventDefault();
		openLoginPhone();
	});

	$('.js-open-menu-my-account').on('click',(e)=>{
		e.preventDefault();
		openLoginPhone();
	});

	//*************************************************************************

})();
